if (!customElements.get('product-form')) {
  
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.productId = this.dataset.productId;
      this.form = this.querySelector('form');
      this.form.querySelector('[name="id"]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartDrawer = document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.buyNowButton = this.querySelector('[data-fast-checkout]');
      this.checkoutInput = this.querySelector('input[name="return_to"][value="/checkout"]');

      if (this.buyNowButton) {
        this.buyNowButton.addEventListener('click', () => {
          this.buyNowButton.setAttribute('aria-disabled', true);
          this.buyNowButton.classList.add('is-loading');
          this.checkoutInput && this.checkoutInput.removeAttribute('disabled');
          this.form.submit();
        });
      }
    }

    onSubmitHandler(event) {
      if (!this.cartDrawer) return;

      event.preventDefault();
      if (this.submitButton.classList.contains('is-loading')) return;

      this.handleErrorMessage();
      this.cartDrawer.setActiveElement(document.activeElement);

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('is-loading');

      const fetchedData = this.addItemToCart();
      this.handleFetchedData(fetchedData);
    }

    addItemToCart() {
      return new Promise((resolve, reject) => {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        
        const formData = new FormData(this.form);
        formData.append('sections', this.cartDrawer.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        window.formDataa = formData;
        console.log("my form " );
        console.log( window.formDataa);

        if($('#member_customerr').length == 0){
          console.log("I am not logged in" );
          $.ajax({
              type: 'GET',
              url: '/cart.js',
              async: false,
              dataType: 'json',
              success: function(cart) {
             
                if(cart.items.find(x => x.handle == 'inveterate-subscription')){
                  
                  var product_id = formData.get('product-id');
                  console.log(" not login"+ product_id)
                  var variant_id = formData.get('id');
                  var pro_handle = window.normal_products.find(x => x.id == product_id).handle;
                  var variant_title = window.normal_products.find(x => x.id == product_id).variants.find(x => x.id == variant_id).title;
                  var set_var_id = window.member_products.find(x => x.handle == pro_handle+'-members-only').variants.find(x => x.title == variant_title).id;
                  var set_pro_id = window.member_products.find(x => x.handle == pro_handle+'-members-only').id;
                  formData.set('id', set_var_id);
                  formData.set('product-id', set_pro_id);
                }
              }
          })
        }else{
          
          var product_id = formData.get('product-id');
          var variant_id = formData.get('id');
          // Find the product based on product_id
          var product = window.normal_products.find(x => x.id == product_id);
          if (product && product.handle) {
            console.log("Product handle exist in membership product");
            var pro_handle = product.handle;
            
            var variant_title = product.variants.find(x => x.id == variant_id).title;

           console.log(89);
           console.log(window.member_products);
            var member_product = window.member_products.find(x => x.handle == pro_handle + '-members-only');
            if (member_product) {
                var member_variant = member_product.variants.find(x => x.title == variant_title);
                if (member_variant) {
                  var set_var_id = member_variant.id;
                  var set_pro_id = member_product.id;
                  formData.set('id', set_var_id);
                  formData.set('product-id', set_pro_id);
                }
            }
            
            else {
              console.log("Variant not found in membership product");
            }
            
            // var set_var_id = window.member_products.find(x => x.handle == pro_handle + '-members-only').variants.find(x => x.title == variant_title).id;
            // var set_pro_id = window.member_products.find(x => x.handle == pro_handle + '-members-only').id;

            // formData.set('id', set_var_id);
            // formData.set('product-id', set_pro_id);
          }

           else{
            console.log("Product handle doesnot exist in membership product");
           }
        }
        
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response) {
              resolve(response);

               if(typeof BOLD === 'object' && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function') {
               BOLD.common.eventEmitter.emit("BOLD_COMMON_cart_loaded");
              }
              return;
            }

            this.submitButton.classList.remove('is-loading');
            this.submitButton.removeAttribute('aria-disabled');          

            reject(response);
          })
          .catch((e) => {
            window.console.error(error);
          });
      });
    }

    handleFetchedData(promise) {
      Promise.all([promise]).then((values) => {
        if (values.length === 0) {
          return;
        }

        const fetchedData = values[0];

        if (fetchedData.status) {
          this.handleErrorMessage(fetchedData.description);
          return;
        }

        this.cartDrawer.handleAddedItem(fetchedData);

        const quickview = document.querySelector(`#Product-Quickview-${this.productId}`);

        if (quickview) {
          quickview.hide();
        }
      })
      .catch((error) => {
        window.console.error(error);
      })
      .finally(() => {
        this.submitButton.classList.remove('is-loading');
        this.submitButton.removeAttribute('aria-disabled');
      });

      setTimeout(function() {
        console.log("loading start");
        window.custom_func();
    }, 1000); // 1000 milliseconds = 1 second
      
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.main-product__form-error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.main-product__form-error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
